import clsx from 'clsx'
import { Loader } from '@/components/Loader'
import { ButtonBase } from '../ButtonBase'
import { IButtonProps } from '../types'
import styles from './styles.module.scss'

const ButtonSuccess = ({ children, className, isLoading, ...props }: IButtonProps) => {
  return (
    <ButtonBase
      data-testid="mui-button-success"
      className={clsx(styles.success, className)}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && <Loader className={styles.loader} />}
      {children}
    </ButtonBase>
  )
}

export default ButtonSuccess
